import { bind, unwrap, toArray as toArray_1, map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { Permission, isAllowed } from "../../RAWMap.Models/Security.js";
import { mkToolReactButton, mkDispatchLocal } from "../Common/CommonView.js";
import { FormField_labeledSlider, FormField_onChangeNumberDispatch, FormField_ReactSelectCallback$1, FormField_reactSelectSingle } from "../../Common/Forms.js";
import { SelectPropsMulti$1 } from "../../Common/ReactSelectBind.js";
import { ImageData_LumenMasks__43A3F7B7, ImageData_VisceralMasks__43A3F7B7, ImageData_WallMasks__43A3F7B7, ImageData_StandardImageFiles__43A3F7B7, DicomViewMode, ViewportLocation, Meshes_Previous_3B5CE845, Meshes_Current_3B5CE845, TargetStudy, InteractionMsg, CardMode, ActiveSegmentation_get_describe, ActiveSegmentation, ActiveSegmentation_get_all, VisualizationType, MeshViewportLocation, DisplayMap_describe } from "../Common/CommonTypes.js";
import { Compare_previousMeshTypes, Compare_previousStudyViewport, VisualizationViewMode_toInteractionMode_Z71EA20FE, OutboundMsg, ModelVisualizationTemp__get_hasModifiedSegmentations, VisualizationViewMode, LocalMsg } from "./VisualizationTempTypes.js";
import * as react from "react";
import { keyValueList } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { lockUnlockTool as lockUnlockTool_1 } from "../Camera/CameraView.js";
import { Shared_onButtonStyles, Shared_defaultButtonStyles } from "../VisualizationShared.js";
import { Fa_IconOption } from "../../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { Helpers_nothing } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { safeHash, int32ToString, equals } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { VisualizationTempInteractionMode, InteractionMode, CommonInteractionMode } from "../Common/CommonBindings.js";
import { screenshotModal, takeScreenshotTool, cancelScreenshotTool } from "../Screenshot/ScreenshotView.js";
import { showSlicePlaneTool } from "../SlicePlane/SlicePlaneView.js";
import { Controls_spinner, Controls_dropdownButton, Forms_formFieldReactSelect } from "../../Common/General.js";
import { append, empty, singleton, delay, toList } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { body, Label_Option, label, Option, div } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Field.fs.js";
import { map as map_1, contains, toArray, empty as empty_1, ofArray, singleton as singleton_1 } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Option as Option_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { printf, toText } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { Option as Option_2, button } from "../../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Common_GenericOption, Size_ISize, Color_IColor } from "../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { wrapInboundMsg, wrapLocalMsg, wrapOutboundMsg } from "../../Common/InboundOutbound.js";
import { Level_Option, level } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { InstitutionClinicalDesignation } from "../../RAWMap.Models/View/Institution.js";
import { Option as Option_3, tag as tag_52 } from "../../fable_modules/Fulma.3.0.0/Elements/Tag.fs.js";
import { ModelCenterlineMeasurement_Props, LocalMsg as LocalMsg_1 } from "../CenterlineMeasurement/CenterlineMeasurementTypes.js";
import { ModelCalipers_Props_69A04C54, LocalMsg as LocalMsg_2 } from "../Calipers/CalipersTypes.js";
import { deleteMeasurementModal, makeAllMeasurementCards } from "../MeasurementsView.js";
import { notesModal, notesCard } from "../Notes/NotesView.js";
import { TableOption, table } from "../../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { content as content_1, Header_icon, Header_title, header, card } from "../../fable_modules/Fulma.3.0.0/Components/Card.fs.js";
import { Option as Option_4, icon as icon_12 } from "../../fable_modules/Fulma.3.0.0/Elements/Icon.fs.js";
import { LengthPropsModel, SlicingMode, eventNames, InteractionModeProps } from "../VisualizationBindings.js";
import { ModelSlicePlane_Props_Z714BB56C, InboundMsg } from "../SlicePlane/SlicePlaneTypes.js";
import { FSharpMap__get_Item } from "../../fable_modules/fable-library-js.4.19.3/Map.js";
import { NotesProps, StaticLabel } from "../Notes/NotesBindings.js";
import { ModelNotes__Props_25828286 } from "../Notes/NotesTypes.js";
import { append as append_1 } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { toString } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { ModelCamera_Props } from "../Camera/CameraTypes.js";
import { ModelScreenshot_Props_Z625F521 } from "../Screenshot/ScreenshotTypes.js";
import { ModelAnatomyOrientation_Props_Z550008EC } from "../AnatomyOrientation/AnatomyOrientationTypes.js";
import { ModelPickedMapValue_Props } from "../PickedMapValue/PickedMapValueTypes.js";
import MeshVisualization from "../../../../src/RAWMap.Client/Visualization/js/MeshVisualization.js";
import DicomVisualization from "../../../../src/RAWMap.Client/Visualization/js/DicomVisualization.js";
import { Card_foot, Card_body, Card_head, Card_card, background, Option as Option_5, modal } from "../../fable_modules/Fulma.3.0.0/Components/Modal.fs.js";
import { mkManagedUpload } from "./VisualizationTempState.js";
import { Common_StudyStatus } from "../../RAWMap.Models/Common.js";
import { content as content_2 } from "../../fable_modules/Fulma.3.0.0/Elements/Content.fs.js";

export function canUserViewCustomReport(model) {
    return defaultArg(map((user) => isAllowed(new Permission(20, []))(user.roles), model.MaybeCurrentUser), false);
}

export function canUserEditCustomReportData(model) {
    return defaultArg(map((user) => isAllowed(new Permission(21, []))(user.roles), model.MaybeCurrentUser), false);
}

function mkMapSelect(dispatch, viewPort, viewMode, maps, selectedMap) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const props = [["style", {
        minWidth: "150px",
    }]];
    const children = [FormField_reactSelectSingle(maps, [], [new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], DisplayMap_describe, selectedMap, new FormField_ReactSelectCallback$1((maybeNewValue) => {
        if (maybeNewValue == null) {
        }
        else {
            dispatchLocal(new LocalMsg(4, [viewPort, maybeNewValue]));
        }
    }), "", [])];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkViewportToolPanel(children) {
    const props = [["style", {
        position: "absolute",
        top: "8px",
        left: "8px",
    }]];
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function mkMainToolPanel(imageData, model, dispatch) {
    let isOn, isOn_1, matchValue_12;
    const dispatchLocal = mkDispatchLocal(dispatch);
    let isToolPanelDisabled;
    const matchValue = model.InteractionMode;
    let matchResult;
    if (matchValue.tag === 0) {
        if (matchValue.fields[0].tag === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            isToolPanelDisabled = false;
            break;
        }
        default:
            isToolPanelDisabled = true;
    }
    const lockUnlockTool = lockUnlockTool_1(isToolPanelDisabled, model.CameraModel, (arg) => {
        dispatchLocal(new LocalMsg(12, [arg]));
    });
    let viewModeTool;
    const matchValue_1 = model.ViewMode;
    viewModeTool = ((matchValue_1.tag === 2) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-square"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, isToolPanelDisabled, "Switch to single view") : ((matchValue_1.tag === 0) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-square"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, true, "Unable to switch views when comparing previous study") : mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-th-large"]), new LocalMsg(6, [new VisualizationViewMode(2, [])]), false, isToolPanelDisabled, "Switch to quad view")));
    let singleViewTool;
    const matchValue_2 = model.ViewMode;
    singleViewTool = ((matchValue_2.tag === 1) ? ((matchValue_2.fields[0].tag === 0) ? mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-brain"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(1, [])])]), false, isToolPanelDisabled, "Show CT slice") : mkToolReactButton(dispatch, Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-cube"]), new LocalMsg(6, [new VisualizationViewMode(1, [new VisualizationType(0, [new MeshViewportLocation(0, [])])])]), false, isToolPanelDisabled, "Show single map")) : Helpers_nothing);
    const patternInput = (model.IsFollowupStudy && model.HasPreviousStudyMaps) ? [(isOn = model.DisplayPreviousStudyMaps, mkToolReactButton(dispatch, isOn ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-history"]), new LocalMsg(10, [!isOn]), false, isToolPanelDisabled, ((_arg) => {
        if (_arg) {
            return "Hide previous study maps";
        }
        else {
            return "Overlay previous study maps";
        }
    })(isOn))), (isOn_1 = equals(model.ViewMode, new VisualizationViewMode(0, [])), mkToolReactButton(dispatch, isOn_1 ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-clone"]), new LocalMsg(6, [(model.ViewMode.tag === 0) ? (new VisualizationViewMode(2, [])) : (new VisualizationViewMode(0, []))]), false, isToolPanelDisabled, ((_arg_1) => {
        if (_arg_1) {
            return "Stop comparing previous study maps";
        }
        else {
            return "Compare with previous study maps";
        }
    })(isOn_1)))] : [Helpers_nothing, Helpers_nothing];
    let isReportsButtonDisabled;
    const matchValue_4 = model.InteractionMode;
    const matchValue_5 = !canUserViewCustomReport(model);
    const matchValue_6 = ModelVisualizationTemp__get_hasModifiedSegmentations(model);
    let matchResult_1;
    if (matchValue_4.tag === 0) {
        if (matchValue_4.fields[0].tag === 0) {
            if (matchValue_5) {
                matchResult_1 = 1;
            }
            else if (matchValue_6) {
                matchResult_1 = 1;
            }
            else {
                matchResult_1 = 0;
            }
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            isReportsButtonDisabled = false;
            break;
        }
        default:
            isReportsButtonDisabled = true;
    }
    let isScreenshotButtonDisabled;
    const matchValue_8 = model.InteractionMode;
    const matchValue_9 = !canUserEditCustomReportData(model);
    const matchValue_10 = ModelVisualizationTemp__get_hasModifiedSegmentations(model);
    let matchResult_2;
    if (matchValue_8.tag === 0) {
        if (matchValue_8.fields[0].tag === 0) {
            if (matchValue_9) {
                matchResult_2 = 1;
            }
            else if (matchValue_10) {
                matchResult_2 = 1;
            }
            else {
                matchResult_2 = 0;
            }
        }
        else {
            matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            isScreenshotButtonDisabled = false;
            break;
        }
        default:
            isScreenshotButtonDisabled = true;
    }
    const screenshotTool = (isScreenshotButtonDisabled && equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])]))) ? cancelScreenshotTool(false, (arg_1) => {
        dispatchLocal(new LocalMsg(15, [arg_1]));
    }) : takeScreenshotTool(isScreenshotButtonDisabled, (arg_2) => {
        dispatchLocal(new LocalMsg(15, [arg_2]));
    });
    const slicePlaneTool = showSlicePlaneTool(false, model.SlicePlaneModel, (arg_3) => {
        dispatchLocal(new LocalMsg(16, [arg_3]));
    });
    const helpTool = mkToolReactButton(dispatch, model.ShowHelpTooltip ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(11, ["fas fa-question-circle"]), new LocalMsg(20, []), false, false, "Help with controls");
    const windowLevelButton = mkToolReactButton(dispatch, !model.ShowMasks ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-circle-half-stroke"]), new LocalMsg(21, [false]), false, false, "Adjust Window/Level");
    const segmentationEditAllowed = equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(0, [])]));
    let segmentationEnableButton;
    const patternInput_1 = ((matchValue_12 = model.ViewMode, (matchValue_12.tag === 1) ? (matchValue_12.fields[0].tag === 1) : (matchValue_12.tag === 2))) ? ["Enable Segmentation", false] : ["Segmentation is not available for this view", true];
    segmentationEnableButton = mkToolReactButton(dispatch, model.ShowMasks ? Shared_onButtonStyles : Shared_defaultButtonStyles, new Fa_IconOption(15, ["fas fa-draw-polygon"]), new LocalMsg(21, [true]), false, patternInput_1[1], patternInput_1[0]);
    let segmentationSelect;
    const visceralFiles = (imageData == null) ? [] : imageData.VisceralMasks;
    const props = [["style", {
        display: "inline-block",
        marginTop: "0",
        marginBottom: "0",
    }]];
    const children = [Forms_formFieldReactSelect([new SelectPropsMulti$1(10, [false]), new SelectPropsMulti$1(11, ["auto"]), new SelectPropsMulti$1(12, ["fixed"])], "", model.ActiveSegmentation, ActiveSegmentation_get_all(), toList(delay(() => ((visceralFiles.length === 0) ? singleton(new ActiveSegmentation(2, [])) : empty()))), ActiveSegmentation_get_describe(), (arg_4) => {
        dispatchLocal(new LocalMsg(30, [arg_4]));
    })];
    segmentationSelect = react.createElement("div", keyValueList(props, 1), ...children);
    let paintingToggle;
    let patternInput_2;
    const matchValue_13 = model.ViewMode;
    const matchValue_14 = model.SegmentationProps.paintingEnabled;
    let matchResult_3;
    switch (matchValue_13.tag) {
        case 1: {
            if (matchValue_13.fields[0].tag === 1) {
                if (matchValue_14) {
                    matchResult_3 = 0;
                }
                else {
                    matchResult_3 = 1;
                }
            }
            else {
                matchResult_3 = 2;
            }
            break;
        }
        case 2: {
            if (matchValue_14) {
                matchResult_3 = 0;
            }
            else {
                matchResult_3 = 1;
            }
            break;
        }
        default:
            matchResult_3 = 2;
    }
    switch (matchResult_3) {
        case 0: {
            patternInput_2 = ["Disable segmentation painting", new Fa_IconOption(15, ["fas fa-paintbrush"]), false];
            break;
        }
        case 1: {
            patternInput_2 = ["Enable segmentation painting", new Fa_IconOption(15, ["fas fa-paintbrush"]), false];
            break;
        }
        default:
            patternInput_2 = ["Segmentation painting is not available for this view", new Fa_IconOption(15, ["fas fa-paintbrush"]), true];
    }
    paintingToggle = mkToolReactButton(dispatch, model.SegmentationProps.paintingEnabled ? Shared_onButtonStyles : Shared_defaultButtonStyles, patternInput_2[1], new LocalMsg(22, [!model.SegmentationProps.paintingEnabled]), false, patternInput_2[2] ? true : !segmentationEditAllowed, patternInput_2[0]);
    const makeHorizontalField = (givenLabel, width, contents) => div(ofArray([new Option(10, ["horizontal-field"]), new Option(8, []), new Option(11, [singleton_1(["style", {
        margin: "0 0.25em 0 0",
        alignItems: "center",
    }])])]), ofArray([label(ofArray([new Label_Option(1, []), new Label_Option(3, [singleton_1(["style", {
        flexBasis: width,
        flexGrow: "0",
        margin: "0",
    }])])]), singleton_1(react.createElement("label", {}, givenLabel))), body(empty_1(), singleton_1(contents))]));
    let brushSizeSlider;
    if (model.SegmentationProps.paintingEnabled) {
        const callback = FormField_onChangeNumberDispatch((maybeNumber) => {
            defaultArg(map((number) => {
                dispatchLocal(new LocalMsg(23, [number]));
            }, maybeNumber), undefined);
        }, model.SegmentationProps.paintingBrushSize);
        brushSizeSlider = makeHorizontalField("Brush Size", "6em", FormField_labeledSlider(1, 50, 1, int32ToString(model.SegmentationProps.paintingBrushSize), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_1(15, [ofArray([new HTMLAttr(158, [`${model.SegmentationProps.paintingBrushSize} px`]), ["style", {
            width: "7em",
        }]])])], callback, "", []));
    }
    else {
        brushSizeSlider = Helpers_nothing;
    }
    let segmentationOpacitySlider;
    if (model.ShowMasks) {
        let opacityValueTooltip;
        const arg_5 = ~~(model.SegmentationProps.segmentationOpacity * 100) | 0;
        opacityValueTooltip = toText(printf("%d%%"))(arg_5);
        const callback_1 = FormField_onChangeNumberDispatch((maybeNumber_1) => {
            defaultArg(map((number_1) => {
                dispatchLocal(new LocalMsg(24, [number_1]));
            }, maybeNumber_1), undefined);
        }, model.SegmentationProps.segmentationOpacity);
        segmentationOpacitySlider = makeHorizontalField("Opacity", "4em", FormField_labeledSlider(0, 1, 0.05, model.SegmentationProps.segmentationOpacity.toString(), [new HTMLAttr(64, ["horizontal-slider"])], [new Option_1(15, [ofArray([new HTMLAttr(158, [opacityValueTooltip]), ["style", {
            width: "7em",
        }]])])], callback_1, "", []));
    }
    else {
        segmentationOpacitySlider = Helpers_nothing;
    }
    let zoomScrollToggle;
    let patternInput_3;
    const matchValue_16 = model.ViewMode;
    const matchValue_17 = model.IsSliceScroll;
    let matchResult_4;
    switch (matchValue_16.tag) {
        case 1: {
            if (matchValue_16.fields[0].tag === 1) {
                if (matchValue_17) {
                    matchResult_4 = 0;
                }
                else {
                    matchResult_4 = 1;
                }
            }
            else {
                matchResult_4 = 2;
            }
            break;
        }
        case 2: {
            if (matchValue_17) {
                matchResult_4 = 0;
            }
            else {
                matchResult_4 = 1;
            }
            break;
        }
        default:
            matchResult_4 = 2;
    }
    switch (matchResult_4) {
        case 0: {
            patternInput_3 = ["Switch mouse wheel action to Zoom", new Fa_IconOption(15, ["fas fa-magnifying-glass"]), false];
            break;
        }
        case 1: {
            patternInput_3 = ["Switch mouse wheel action to Scroll CT Slices", new Fa_IconOption(15, ["fas fa-arrow-down-up-across-line"]), false];
            break;
        }
        default:
            patternInput_3 = ["Scrolling is not available in for this view", new Fa_IconOption(15, ["fas fa-arrow-down-up-across-line"]), true];
    }
    zoomScrollToggle = mkToolReactButton(dispatch, Shared_defaultButtonStyles, patternInput_3[1], new LocalMsg(7, [!model.IsSliceScroll]), false, patternInput_3[2], patternInput_3[0]);
    const backToStudyButton = button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(16, [isToolPanelDisabled]), new Option_2(17, [ofArray([new HTMLAttr(99, ["backToStudy"]), new DOMAttr(40, [(_arg_3) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(2, [])));
    }])])])]), singleton_1("Back to Study"));
    let customReportButton;
    const handler = (model.PatientInstitutionDesignation.tag === 1) ? ((_arg_5) => {
        dispatchLocal(new LocalMsg(39, [true]));
    }) : ((_arg_4) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [model.SelectedStudy, model.CustomReportData])));
    });
    customReportButton = button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(16, [isReportsButtonDisabled]), new Option_2(17, [ofArray([["style", {
        marginLeft: 5,
    }], new DOMAttr(40, [handler])])])]), singleton_1("Generate Report"));
    const submitForReanalysisButton = button(ofArray([new Option_2(17, [singleton_1(["style", {
        marginLeft: "auto",
    }])]), new Option_2(0, [new Color_IColor(7, [])]), new Option_2(16, [(isToolPanelDisabled ? true : model.ReanalysisSubmitted) ? true : !ModelVisualizationTemp__get_hasModifiedSegmentations(model)]), new Option_2(17, [ofArray([new HTMLAttr(99, ["submitForReanalysis"]), new DOMAttr(40, [(_arg_6) => {
        dispatch(wrapLocalMsg(new LocalMsg(32, [true])));
    }])])])]), singleton_1("Submit for Reanalysis"));
    let verticalDivider;
    const props_4 = [new HTMLAttr(64, ["is-divider"]), ["style", {
        width: "1px",
        backgroundColor: "#ccc",
        marginLeft: "0.5rem",
        marginRight: "0.5rem",
    }]];
    verticalDivider = react.createElement("div", keyValueList(props_4, 1));
    const group = (elements) => level(singleton_1(new Level_Option(0, [singleton_1(["style", {
        marginBottom: 0,
    }])])), elements);
    const children_6 = toList(delay(() => append(singleton(group(ofArray([backToStudyButton, customReportButton]))), delay(() => append(singleton(group(ofArray([helpTool, lockUnlockTool, viewModeTool, singleViewTool, screenshotTool, slicePlaneTool, patternInput[1], zoomScrollToggle]))), delay(() => append(equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) ? append(singleton(group(singleton_1(windowLevelButton))), delay(() => append(singleton(verticalDivider), delay(() => append(singleton(group(singleton_1(segmentationEnableButton))), delay(() => (model.ShowMasks ? singleton(group(ofArray([segmentationSelect, segmentationOpacitySlider, paintingToggle, brushSizeSlider]))) : empty()))))))) : empty(), delay(() => {
        let _arg_2;
        return append(singleton(defaultArg(map((desc_14) => {
            const message = toText(printf("Active Mode: %s"))(desc_14);
            return tag_52(ofArray([new Option_3(1, [new Color_IColor(7, [])]), new Option_3(0, [new Size_ISize(2, [])]), new Option_3(5, ["active-mode-indicator"]), new Option_3(4, [singleton_1(["style", {
                whiteSpace: "normal",
                height: "auto",
            }])])]), singleton_1(message));
        }, (_arg_2 = model.InteractionMode, (_arg_2.tag === 0) ? ((_arg_2.fields[0].tag === 1) ? (equals(model.ViewMode, new VisualizationViewMode(2, [])) ? "Screenshot - Select a viewport to capture it" : undefined) : ((_arg_2.fields[0].tag === 3) ? "Local diameter measurement" : ((_arg_2.fields[0].tag === 4) ? "Volume measurement" : ((_arg_2.fields[0].tag === 0) ? undefined : "Centerline distance measurement")))) : ((_arg_2.fields[0].tag === 1) ? "Moving measurement note" : ((_arg_2.fields[0].tag === 2) ? "Calipers measurement" : ((_arg_2.fields[0].tag === 3) ? "Diameter range measurement" : "Moving notes"))))), Helpers_nothing)), delay(() => {
            const canUserRequestReanalysis = defaultArg(map((user) => isAllowed(new Permission(27, []))(user.roles), model.MaybeCurrentUser), false);
            return (equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) && canUserRequestReanalysis) ? singleton(submitForReanalysisButton) : empty();
        }));
    }))))))));
    return react.createElement("div", {
        className: "visualization-toolbar",
    }, ...children_6);
}

export function allMeasurementsCards(model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    const allButtons = toList(delay(() => append(singleton((dispatch_2) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_1) => {
        dispatch_2(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(8, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Centerline Distance"))), delay(() => append(singleton((dispatch_3) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_2) => {
        dispatch_3(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(9, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Diameter Range"))), delay(() => append(singleton((dispatch_4) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_3) => {
        dispatch_4(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(10, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Local Diameter"))), delay(() => append(singleton((dispatch_5) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg_4) => {
        dispatch_5(new LocalMsg(14, [wrapLocalMsg(new LocalMsg_1(11, [equals(model.ViewMode, new VisualizationViewMode(0, []))]))]));
    }]), "Volume"))), delay(() => (!equals(model.ViewMode, new VisualizationViewMode(0, [])) ? singleton((dispatch_1) => (new Controls_dropdownButton(new DOMAttr(40, [(_arg) => {
        dispatch_1(new LocalMsg(13, [wrapLocalMsg(new LocalMsg_2(4, []))]));
    }]), "Caliper"))) : empty())))))))))));
    return makeAllMeasurementCards(model, model.Measurements, (equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) ? true : equals(model.InteractionMode, new InteractionMode(1, [new VisualizationTempInteractionMode(0, [])]))) ? (new CardMode(2, [])) : ((!canUserEditCustomReportData(model) ? true : ModelVisualizationTemp__get_hasModifiedSegmentations(model)) ? (new CardMode(1, [])) : (new CardMode(0, []))), allButtons, dispatchLocal);
}

export function staticNotesCard(model, dispatch) {
    return notesCard(model.NotesModel, (!canUserEditCustomReportData(model) ? true : ModelVisualizationTemp__get_hasModifiedSegmentations(model)) ? (new CardMode(1, [])) : (!equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(0, [])])) ? (new CardMode(2, [])) : (new CardMode(0, []))), dispatch);
}

export function helpToolTipsCardOption(model, dispatch) {
    let children_10, children_2, children_8, children_48, children_16, children_22, children_28, children_34, children_40, children_46, children_62, children_54, children_60, children_100, children_68, children_74, children_80, children_86, children_92, children_98;
    if (model.ShowHelpTooltip) {
        let dicomTips;
        const children_50 = [table(singleton_1(new TableOption(2, [])), ofArray([(children_10 = [(children_2 = [react.createElement("th", {
            colSpan: 2,
        }, "CT Slice Viewport")], react.createElement("tr", {}, ...children_2)), (children_8 = [react.createElement("th", {}, "Action"), react.createElement("th", {}, "Controls")], react.createElement("tr", {}, ...children_8))], react.createElement("thead", {}, ...children_10)), (children_48 = [(children_16 = [react.createElement("td", {}, "Pan"), react.createElement("td", {}, "Shift + Left Click + Drag")], react.createElement("tr", {}, ...children_16)), (children_22 = [react.createElement("td", {}, "Window"), react.createElement("td", {}, "Click Window/Level button, then Left Click + Drag Horizontally")], react.createElement("tr", {}, ...children_22)), (children_28 = [react.createElement("td", {}, "Level"), react.createElement("td", {}, "Click Window/Level button, then Left Click + Drag Vertically")], react.createElement("tr", {}, ...children_28)), (children_34 = [react.createElement("td", {}, "Scroll Slice"), react.createElement("td", {}, "Middle Mouse Wheel (when mouse wheel action is set to scroll)")], react.createElement("tr", {}, ...children_34)), (children_40 = [react.createElement("td", {}, "Scroll Slice (Fast)"), react.createElement("td", {}, "Ctrl + Left Click + Drag Vertically")], react.createElement("tr", {}, ...children_40)), (children_46 = [react.createElement("td", {}, "Zoom"), react.createElement("td", {}, "Shift + Alt + Left Click + Drag")], react.createElement("tr", {}, ...children_46))], react.createElement("tbody", {}, ...children_48))]))];
        dicomTips = react.createElement("div", {}, ...children_50);
        let mapTips;
        const children_102 = [table(singleton_1(new TableOption(2, [])), ofArray([(children_62 = [(children_54 = [react.createElement("th", {
            colSpan: 2,
        }, "Map Viewports")], react.createElement("tr", {}, ...children_54)), (children_60 = [react.createElement("th", {}, "Action"), react.createElement("th", {}, "Controls")], react.createElement("tr", {}, ...children_60))], react.createElement("thead", {}, ...children_62)), (children_100 = [(children_68 = [react.createElement("td", {}, "Free Rotate"), react.createElement("td", {}, "Left Click + Drag")], react.createElement("tr", {}, ...children_68)), (children_74 = [react.createElement("td", {}, "CC/CCW Rotate"), react.createElement("td", {}, "Ctrl + Left Click + Drag")], react.createElement("tr", {}, ...children_74)), (children_80 = [react.createElement("td", {}, "Pan"), react.createElement("td", {}, "Shift + Left Click + Drag")], react.createElement("tr", {}, ...children_80)), (children_86 = [react.createElement("td", {}, "Zoom"), react.createElement("td", {}, "Middle Mouse Wheel (when mouse wheel action is set to zoom)")], react.createElement("tr", {}, ...children_86)), (children_92 = [react.createElement("td", {}, "Add Point Measurement"), react.createElement("td", {}, "Right Click on Map")], react.createElement("tr", {}, ...children_92)), (children_98 = [react.createElement("td", {}, "Clear Point Measurement"), react.createElement("td", {}, "Right Click Outside Map")], react.createElement("tr", {}, ...children_98))], react.createElement("tbody", {}, ...children_100))]))];
        mapTips = react.createElement("div", {}, ...children_102);
        return singleton_1(card(empty_1(), ofArray([header(empty_1(), ofArray([Header_title(empty_1(), singleton_1("Tool Tips")), Header_icon(singleton_1(new Common_GenericOption(1, [singleton_1(["style", {
            color: "inherit ",
        }])])), singleton_1(button(ofArray([new Option_2(17, [singleton_1(new HTMLAttr(158, ["Close"]))]), new Option_2(17, [ofArray([new DOMAttr(40, [(_arg) => {
            dispatch(new LocalMsg(20, []));
        }]), new HTMLAttr(159, ["button"])])]), new Option_2(0, [new Color_IColor(2, [])])]), singleton_1(icon_12(singleton_1(new Option_4(4, [singleton_1(["style", {
            fontWeight: "1000",
        }])])), singleton_1("x"))))))])), content_1(singleton_1(new Common_GenericOption(1, [singleton_1(["style", {
            padding: "0.5rem 1rem",
            margin: "1rem 0",
        }])])), ofArray([dicomTips, mapTips]))])));
    }
    else {
        return undefined;
    }
}

export function interactiveView(loadingStatus, imageData, model, dispatch) {
    const dispatchLocal = mkDispatchLocal(dispatch);
    let viewportClassNames;
    const arg = equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) ? " screenshot-ready" : "";
    viewportClassNames = toText(printf("layout-view-view-container%s"))(arg);
    const interactionProps = (vt) => (new InteractionModeProps(model.InteractionMode, VisualizationViewMode_toInteractionMode_Z71EA20FE(vt)(model.ViewMode)));
    const dispatchToggleHoverMsg = (h) => {
        const matchValue = model.InteractionMode;
        let matchResult;
        if (matchValue.tag === 0) {
            if (matchValue.fields[0].tag === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                break;
            }
            case 1: {
                dispatchLocal(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(2, [h]))]));
                break;
            }
        }
    };
    const meshViewport = (toDisplay, meshViewportLocation, model_1, dispatch_1) => {
        let props_2;
        const dispatchLocal_1 = mkDispatchLocal(dispatch_1);
        const viewPortArgs = FSharpMap__get_Item(model_1.ViewportSelectedMap, meshViewportLocation);
        const onViewportResized = (meshViewportLocation.tag === 0) ? ((arg_2) => {
            dispatchLocal_1(new LocalMsg(8, [new InteractionMsg(arg_2)]));
        }) : ((value) => {
        });
        const showingPreviousOnly = equals(model_1.ViewMode, new VisualizationViewMode(0, [])) && equals(meshViewportLocation, Compare_previousStudyViewport);
        const target = showingPreviousOnly ? (new TargetStudy(1, [])) : (new TargetStudy(0, []));
        const measurementNotes = toArray(ofArray(toArray_1(map((entry) => {
            let arg_4;
            return new StaticLabel(entry.measurementIdUnified, (arg_4 = (!showingPreviousOnly ? entry.coreValues.currentValue : defaultArg(entry.coreValues.maybePreviousValue, "?")), toText(printf("%s: %s"))(entry.coreValues.name)(arg_4)), entry.coreValues.position[1], entry.coreValues.position[0].x, entry.coreValues.position[0].y, undefined, undefined, false, false);
        }, model_1.Measurements.activeMeasurement))));
        let staticNotesProps;
        const props = ModelNotes__Props_25828286(model_1.NotesModel, (arg_5) => {
            dispatchLocal_1(new LocalMsg(11, [arg_5]));
        });
        let matchResult_1;
        if (model_1.ViewMode.tag === 0) {
            if (contains(new VisualizationType(0, [meshViewportLocation]), Compare_previousMeshTypes, {
                Equals: equals,
                GetHashCode: safeHash,
            })) {
                matchResult_1 = 0;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                staticNotesProps = (new NotesProps(append_1([new StaticLabel("00000000-0000-0000-0000-000000000000", equals(meshViewportLocation, Compare_previousStudyViewport) ? "Previous Study" : "Current Study", 0, 0, 0, undefined, undefined, false, true)], props.staticLabels), props.wrapLines, props.worldLabels, props.onStaticLabelDragEnd));
                break;
            }
            default:
                staticNotesProps = props;
        }
        const props_3 = [new HTMLAttr(99, [toString(meshViewportLocation)]), new HTMLAttr(65, [viewportClassNames]), new DOMAttr(52, [(_arg) => {
            dispatchToggleHoverMsg(model_1.IsSliceScroll);
        }]), new DOMAttr(53, [(_arg_1) => {
            dispatchToggleHoverMsg(false);
        }]), ["style", keyValueList([toDisplay(new VisualizationType(0, [meshViewportLocation]))], 1)]];
        const children_1 = [(props_2 = {
            viewportId: toString(meshViewportLocation),
            currentStudyMeshes: unwrap(map(Meshes_Current_3B5CE845, FSharpMap__get_Item(model_1.Meshes, meshViewportLocation))),
            previousStudyMeshes: unwrap(bind(Meshes_Previous_3B5CE845, FSharpMap__get_Item(model_1.Meshes, meshViewportLocation))),
            showPreviousStudyMapsOnly: showingPreviousOnly,
            selectedMap: viewPortArgs.map,
            showCenterline: model_1.DisplayCenterline,
            overlayPreviousStudyMaps: model_1.DisplayPreviousStudyMaps,
            interactionModeProps: interactionProps(new VisualizationType(0, [meshViewportLocation])),
            onViewportResized: onViewportResized,
            staticNotesProps: staticNotesProps,
            measurementNotesProps: new NotesProps(measurementNotes, (x_3) => x_3, new Array(0), (note) => {
                dispatchLocal_1(new LocalMsg(19, [note]));
            }),
            cameraProps: ModelCamera_Props(viewPortArgs.planeAdjustment, (arg_6) => {
                dispatchLocal_1(new LocalMsg(12, [arg_6]));
            }, model_1.CameraModel),
            calipersProps: ModelCalipers_Props_69A04C54(model_1.CalipersModel),
            centerlineMeasurementProps: ModelCenterlineMeasurement_Props(target, model_1.CenterlineMeasurementModel),
            screenshotProps: ModelScreenshot_Props_Z625F521((arg_7) => {
                dispatchLocal_1(new LocalMsg(15, [arg_7]));
            }),
            slicePlaneProps: [ModelSlicePlane_Props_Z714BB56C(model_1.SlicePlaneModel)],
            anatomyOrientationProps: ModelAnatomyOrientation_Props_Z550008EC(model_1.AnatomyOrientationModel),
            pickedMapValueProps: ModelPickedMapValue_Props(model_1.PickedMapValueModel, new ViewportLocation(0, [meshViewportLocation]), (arg_8) => {
                dispatchLocal_1(new LocalMsg(18, [arg_8]));
            }),
            meshViewportLocation: new ViewportLocation(0, [meshViewportLocation]),
            isSliceScroll: model_1.IsSliceScroll,
            onMeshSliceChange: (arg_11) => {
                dispatchLocal_1(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(1, [arg_11]))]));
            },
            isStentPlanning: false,
            showStentPlanningCenterlines: false,
            onRotationChange: (value_3) => {
            },
            eventNames: eventNames,
            selectedDicomView: new DicomViewMode(0, []),
            onVisualizationReady: (tupledArg) => {
                dispatch_1(wrapOutboundMsg(new OutboundMsg(3, [tupledArg[0], tupledArg[1]])));
            },
            rawThreshold: model_1.RawThreshold,
            onRawThresholdChange: (arg_12) => {
                dispatchLocal_1(new LocalMsg(25, [arg_12]));
            },
        }, react.createElement(MeshVisualization, props_2)), mkViewportToolPanel([mkMapSelect(dispatch_1, meshViewportLocation, model_1.ViewMode, model_1.AvailableMaps, viewPortArgs.map)])];
        return react.createElement("div", keyValueList(props_3, 1), ...children_1);
    };
    const toDisplay_1 = (visualizationType) => {
        let matchValue_2;
        return new CSSProp(125, [(matchValue_2 = model.ViewMode, (matchValue_2.tag === 1) ? (equals(matchValue_2.fields[0], visualizationType) ? "block" : "none") : ((matchValue_2.tag === 0) ? (contains(visualizationType, Compare_previousMeshTypes, {
            Equals: equals,
            GetHashCode: safeHash,
        }) ? "block" : "none") : "block"))]);
    };
    let visualizationContainer;
    const matchValue_3 = model.ViewMode;
    switch (matchValue_3.tag) {
        case 1: {
            const props_8 = singleton_1(["style", {
                height: "100%",
            }]);
            visualizationContainer = ((children_6) => react.createElement("div", keyValueList(props_8, 1), ...children_6));
            break;
        }
        case 0: {
            const props_11 = ofArray([new HTMLAttr(65, ["layout-view-grid"]), ["style", {
                height: "100%",
                gridTemplateRows: "auto",
                gridTemplateColumns: "1fr 1fr",
            }]]);
            visualizationContainer = ((children_9) => react.createElement("div", keyValueList(props_11, 1), ...children_9));
            break;
        }
        default: {
            const props_5 = ofArray([new HTMLAttr(65, ["layout-view-grid"]), ["style", {
                gridTemplateRows: "1fr 1fr",
                gridTemplateColumns: "1fr 1fr",
            }]]);
            visualizationContainer = ((children_3) => react.createElement("div", keyValueList(props_5, 1), ...children_3));
        }
    }
    const children_21 = toList(delay(() => {
        let matchValue_4;
        return append((matchValue_4 = loadingStatus, (matchValue_4.tag === 2) ? singleton(Controls_spinner("Extracting...")) : ((matchValue_4.tag === 3) ? singleton(Controls_spinner("Rendering...")) : ((matchValue_4.tag === 0) ? singleton(Helpers_nothing) : ((matchValue_4.tag === 4) ? singleton(Helpers_nothing) : singleton(Controls_spinner("Downloading...")))))), delay(() => {
            let props_22, children_19, children_17, props_16, children_13, props_15, props_18;
            return singleton((props_22 = [new HTMLAttr(65, ["visualization-dynamic-height"]), ["style", {
                visibility: (loadingStatus.tag === 4) ? "visible" : "hidden",
            }]], (children_19 = [mkMainToolPanel(imageData, model, dispatch), (children_17 = [visualizationContainer(ofArray([(props_16 = [new HTMLAttr(65, [viewportClassNames]), new DOMAttr(52, [(_arg_2) => {
                dispatchToggleHoverMsg(true);
            }]), new DOMAttr(53, [(_arg_3) => {
                dispatchToggleHoverMsg(false);
            }]), ["style", keyValueList([toDisplay_1(new VisualizationType(1, []))], 1)]], (children_13 = [(props_15 = {
                viewportId: "DicomViewport",
                imageFiles: defaultArg(map(ImageData_StandardImageFiles__43A3F7B7, imageData), new Array(0)),
                maskFiles: defaultArg(map((dicom) => {
                    const matchValue_5 = model.ActiveSegmentation;
                    switch (matchValue_5.tag) {
                        case 1:
                            return ImageData_WallMasks__43A3F7B7(dicom);
                        case 2:
                            return ImageData_VisceralMasks__43A3F7B7(dicom);
                        default:
                            return ImageData_LumenMasks__43A3F7B7(dicom);
                    }
                }, imageData), new Array(0)),
                showMasks: model.ShowMasks,
                onSliceChange: (arg_15) => {
                    dispatchLocal(new LocalMsg(16, [wrapInboundMsg(new InboundMsg(0, [arg_15]))]));
                },
                onTouchStart: (e) => {
                    if (e.touches.length === 1) {
                        dispatchToggleHoverMsg(true);
                    }
                },
                onTouchEnd: (_arg_4) => {
                    dispatchToggleHoverMsg(false);
                },
                interactionModeProps: interactionProps(new VisualizationType(1, [])),
                screenshotProps: ModelScreenshot_Props_Z625F521((arg_16) => {
                    dispatchLocal(new LocalMsg(15, [arg_16]));
                }),
                isSliceScroll: model.IsSliceScroll,
                slicePlaneIndex: unwrap(model.SlicePlaneModel.Index),
                segmentationProps: model.SegmentationProps,
                slicingMode: new SlicingMode(0, []),
                lengthProps: new LengthPropsModel(toArray(model.DicomLengthMeasurementIds), model.LengthMeasurementState, () => {
                    dispatchLocal(new LocalMsg(28, []));
                }, (dicomLengthMeasurementId) => {
                    dispatchLocal(new LocalMsg(29, [dicomLengthMeasurementId]));
                }),
                activeWidget: unwrap(model.MaybeActiveWidget),
                imageLoader: model.ImageLoader,
                modifiedSegmentations: [],
                onVisualizationReady: (tupledArg_1) => {
                    dispatch(wrapOutboundMsg(new OutboundMsg(3, [tupledArg_1[0], tupledArg_1[1]])));
                },
                axialSegmentationChangedCallback: (i, data) => {
                    dispatchLocal(new LocalMsg(31, [i, data.buffer]));
                },
            }, react.createElement(DicomVisualization, props_15))], react.createElement("div", keyValueList(props_16, 1), ...children_13))), meshViewport(toDisplay_1, new MeshViewportLocation(0, []), model, dispatch), meshViewport(toDisplay_1, new MeshViewportLocation(1, []), model, dispatch), meshViewport(toDisplay_1, new MeshViewportLocation(2, []), model, dispatch)])), (props_18 = [["style", keyValueList(toList(delay(() => append(singleton(new CSSProp(395, ["100%"])), delay(() => append(singleton(new CSSProp(189, ["100%"])), delay(() => append(singleton(new CSSProp(291, ["relative"])), delay(() => append(singleton(new CSSProp(83, ["100%"])), delay(() => ((equals(model.InteractionMode, new InteractionMode(0, [new CommonInteractionMode(1, [])])) && !equals(model.ViewMode, new VisualizationViewMode(2, []))) ? singleton(new CSSProp(383, ["visible"])) : singleton(new CSSProp(383, ["hidden"]))))))))))))), 1)]], react.createElement("div", keyValueList(props_18, 1)))], react.createElement("div", {
                className: "viewports-height-correction",
            }, ...children_17))], react.createElement("div", keyValueList(props_22, 1), ...children_19))));
        }));
    }));
    return react.createElement("div", {}, ...children_21);
}

export function submitForReanalysisModal(model, dispatch) {
    const hideModal = (_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(32, [false])));
    };
    return modal(singleton_1(new Option_5(1, [model.SubmitReanalysisModalVisible])), ofArray([background(singleton_1(new Common_GenericOption(1, [singleton_1(new DOMAttr(40, [hideModal]))])), empty_1()), Card_card(empty_1(), ofArray([Card_head(empty_1(), singleton_1("Submit For Re-Analysis")), Card_body(empty_1(), ofArray([react.createElement("div", {}, "Are you sure you want to submit the updated segmentations for re-analysis?"), react.createElement("div", {}, "You won\'t be able to view or make changes to this study until re-analysis is complete.")])), Card_foot(empty_1(), ofArray([button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(17, [singleton_1(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(33, [map_1((activeSegmentation) => mkManagedUpload(model, activeSegmentation), ActiveSegmentation_get_all())])));
    }]))])]), singleton_1("Submit")), button(singleton_1(new Option_2(17, [singleton_1(new DOMAttr(40, [hideModal]))])), singleton_1("Cancel"))]))]))]));
}

export function reanalysisSubmitted(model, dispatch) {
    let children, s_1;
    return modal(singleton_1(new Option_5(1, [equals(model.SelectedStudy.status, new Common_StudyStatus(5, []))])), ofArray([background(empty_1(), empty_1()), Card_card(empty_1(), ofArray([Card_head(empty_1(), singleton_1("Study Has Been Submitted For Re-Analysis")), Card_body(empty_1(), singleton_1((children = [(s_1 = "This study has been submitted for re-analysis and will be locked until re-analysis is complete. You will now be returned to the study page.", s_1)], react.createElement("div", {}, ...children)))), Card_foot(empty_1(), singleton_1(button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(17, [singleton_1(new DOMAttr(40, [(_arg) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(2, [])));
    }]))])]), singleton_1("Ok"))))]))]));
}

export function segmentationLockWarningModal(model, dispatch) {
    let children_8, children_2, s_2, children_4, s_3, children_6, s_4;
    return modal(singleton_1(new Option_5(1, [model.SegmentationLockWarningModalVisible])), singleton_1(Card_card(empty_1(), ofArray([Card_head(empty_1(), singleton_1("Segmentation Warning")), Card_body(empty_1(), singleton_1(content_2(empty_1(), singleton_1((children_8 = [react.createElement("li", {}, "Making segmentations will lock out measurements and report generation."), (children_2 = [(s_2 = "Segmentations are only valid within this session — you must submit them for reanalysis to keep them.", s_2)], react.createElement("li", {}, ...children_2)), (children_4 = [(s_3 = "Refresh the page to reset any segmentations created and unlock the measurements and report generation functionality", s_3)], react.createElement("li", {}, ...children_4)), (children_6 = [(s_4 = "Do not leave the system unattended once you start to create segmentations. If you are automatically logged out by the system after 10 minutes of inactivity, all segmentations will be reset.", s_4)], react.createElement("li", {}, ...children_6))], react.createElement("ul", {}, ...children_8)))))), Card_foot(empty_1(), singleton_1(button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(17, [singleton_1(new DOMAttr(40, [(_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(36, [false])));
    }]))])]), singleton_1("Acknowledge"))))]))));
}

export function customReportSegementationReviewConfirmationModal(model, dispatch) {
    let children_4, children_2, s_2;
    return modal(singleton_1(new Option_5(1, [model.CustomReportSegmentationConfirmationModalVisible])), singleton_1(Card_card(empty_1(), ofArray([Card_head(empty_1(), singleton_1("Report Generation")), Card_body(empty_1(), singleton_1((children_4 = [react.createElement("p", {}, "Please ensure you have reviewed the segmentations and the quality of all measurements made."), (children_2 = [(s_2 = "If you have not, click the Cancel button to return to the visualization and review or adjust the segmentations and measurements.", s_2)], react.createElement("p", {}, ...children_2))], react.createElement("div", {}, ...children_4)))), Card_foot(empty_1(), ofArray([button(ofArray([new Option_2(0, [new Color_IColor(6, [])]), new Option_2(17, [singleton_1(new DOMAttr(40, [(_arg_1) => {
        dispatch(wrapOutboundMsg(new OutboundMsg(1, [model.SelectedStudy, model.CustomReportData])));
    }]))])]), singleton_1("Generate Report")), button(singleton_1(new Option_2(17, [singleton_1(new DOMAttr(40, [(_arg) => {
        dispatch(wrapLocalMsg(new LocalMsg(39, [false])));
    }]))])), singleton_1("Cancel"))]))]))));
}

export function view(loadingStatus, imageData, model, dispatch) {
    const children = toList(delay(() => append(singleton(interactiveView(loadingStatus, imageData, model, dispatch)), delay(() => append(equals(model.PatientInstitutionDesignation, new InstitutionClinicalDesignation(1, [])) ? append(singleton(submitForReanalysisModal(model, dispatch)), delay(() => append(singleton(reanalysisSubmitted(model, dispatch)), delay(() => append(singleton(segmentationLockWarningModal(model, dispatch)), delay(() => singleton(customReportSegementationReviewConfirmationModal(model, dispatch)))))))) : empty(), delay(() => append(singleton(notesModal(model.NotesModel, (arg_1) => {
        dispatch(wrapLocalMsg(new LocalMsg(11, [arg_1])));
    })), delay(() => append(singleton(deleteMeasurementModal(model, model.Measurements, (arg_2) => {
        dispatch(wrapLocalMsg(arg_2));
    })), delay(() => singleton(screenshotModal(model.ScreenshotModel, (arg_4) => {
        dispatch(wrapLocalMsg(new LocalMsg(15, [arg_4])));
    }, !canUserEditCustomReportData(model)))))))))))));
    return react.createElement(react.Fragment, {}, ...children);
}

